import React from "react";

/** Inline tab bar, tema-aware, sin dependencias externas. */
export default function TabBar({ tabs, active, onChange, testIdPrefix }) {
    return (
        <div
            role="tablist"
            style={{
                display: "flex",
                gap: 4,
                borderBottom: "1px solid var(--border)",
                marginBottom: 14,
            }}
        >
            {tabs.map((t) => {
                const isActive = active === t.key;
                return (
                    <button
                        type="button"
                        key={t.key}
                        role="tab"
                        aria-selected={isActive}
                        onClick={() => onChange(t.key)}
                        data-testid={`${testIdPrefix}-tab-${t.key}`}
                        style={{
                            padding: "8px 14px",
                            background: "transparent",
                            border: "none",
                            borderBottom: isActive ? "2px solid var(--accent)" : "2px solid transparent",
                            marginBottom: -1,
                            color: isActive ? "var(--text)" : "var(--text-muted)",
                            cursor: "pointer",
                            fontSize: 13,
                            fontWeight: isActive ? 600 : 500,
                            transition: "color 120ms, border-color 120ms",
                        }}
                    >
                        {t.label}
                    </button>
                );
            })}
        </div>
    );
}
